import loadable from "@loadable/component";

const NoBrandPageRoute = loadable(() =>
  import(
    /* webpackPreload: true, webpackChunkName: "BRAND_UNAVAILABLE" */ "../NoBrandPage"
  )
);

export default NoBrandPageRoute;
